import { useState, useEffect } from "react";
import { AnnouncementBar } from "./AnnouncementBar";
import { Navbar } from "./Navbar";
import { Hero } from "./Hero";
import { Marquee } from "./Marquee";
import { Collections } from "./Collections";
import { BestSellers } from "./BestSellers";
import { CraftBanner } from "./CraftBanner";
import { WhyChoose } from "./WhyChoose";
import { Testimonials } from "./Testimonials";
import { Newsletter } from "./Newsletter";
import { Footer } from "./Footer";
import { Reveal } from "@/components/motion/Reveal";
import { CandleSplash } from "./CandleSplash";

export function Home() {
  const [showSplash, setShowSplash] = useState(true);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
    if (sessionStorage.getItem("royal_splash_shown")) {
      setShowSplash(false);
    } else {
      // Mark immediately so refreshing won't show the splash again
      sessionStorage.setItem("royal_splash_shown", "true");
    }
  }, []);

  if (!mounted) {
    // Prevent any initial flash of content during hydration
    return <div className="min-h-screen bg-[#0c0c0c]" />;
  }

  return (
    <div className="min-h-screen bg-background text-foreground">
      {/* Splash always renders on top as a fixed overlay, homepage is always below */}
      {showSplash && <CandleSplash />}
      <AnnouncementBar />
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Reveal><Collections /></Reveal>
        <Reveal><BestSellers /></Reveal>
        <Reveal><CraftBanner /></Reveal>
        <Reveal><WhyChoose /></Reveal>
        <Reveal><Testimonials /></Reveal>
        <Reveal><Newsletter /></Reveal>
      </main>
      <Footer />
    </div>
  );
}